module.exports = __webpack_public_path__ + "static/assets/d636d4676e9b68ff0a06f97ec1010ccd.png";